import type {Editor} from "@tiptap/core";
import {NodeSelection} from "@tiptap/pm/state";
import type {VariableAttributes} from "../model/types";
import {VARIABLE_NODE_NAME} from "../model/variableToken";

/** The chip the editor has selected: where it is, what it holds, and whether this editor may change it. */
export type SelectedVariable = {pos: number; key: string; editable: boolean} & VariableAttributes;

/** The chip the editor has selected, or null when it is not on one. */
export function selectedVariable(editor: Editor | null): SelectedVariable | null {
    const selection = editor?.state.selection;
    if (!editor || !(selection instanceof NodeSelection) || selection.node.type.name !== VARIABLE_NODE_NAME) {
        return null;
    }

    const {attrs} = selection.node;

    return {
        pos: selection.from,
        key: attrs.key as string,
        fallback: (attrs.fallback as string | null) ?? "",
        format: (attrs.format as string | null) ?? "",
        editable: editor.isEditable,
    };
}

export default selectedVariable;
